/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as components from "../components/index.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type SetConnectionLimitsConnectionsConnectionIdLimitPutRequest = {
  connectionId: string;
  connectionLimitParams: components.ConnectionLimitParams;
};

/** @internal */
export const SetConnectionLimitsConnectionsConnectionIdLimitPutRequest$inboundSchema:
  z.ZodType<
    SetConnectionLimitsConnectionsConnectionIdLimitPutRequest,
    z.ZodTypeDef,
    unknown
  > = z.object({
    connection_id: z.string(),
    ConnectionLimitParams: components.ConnectionLimitParams$inboundSchema,
  }).transform((v) => {
    return remap$(v, {
      "connection_id": "connectionId",
      "ConnectionLimitParams": "connectionLimitParams",
    });
  });
/** @internal */
export type SetConnectionLimitsConnectionsConnectionIdLimitPutRequest$Outbound =
  {
    connection_id: string;
    ConnectionLimitParams: components.ConnectionLimitParams$Outbound;
  };

/** @internal */
export const SetConnectionLimitsConnectionsConnectionIdLimitPutRequest$outboundSchema:
  z.ZodType<
    SetConnectionLimitsConnectionsConnectionIdLimitPutRequest$Outbound,
    z.ZodTypeDef,
    SetConnectionLimitsConnectionsConnectionIdLimitPutRequest
  > = z.object({
    connectionId: z.string(),
    connectionLimitParams: components.ConnectionLimitParams$outboundSchema,
  }).transform((v) => {
    return remap$(v, {
      connectionId: "connection_id",
      connectionLimitParams: "ConnectionLimitParams",
    });
  });

export function setConnectionLimitsConnectionsConnectionIdLimitPutRequestToJSON(
  setConnectionLimitsConnectionsConnectionIdLimitPutRequest:
    SetConnectionLimitsConnectionsConnectionIdLimitPutRequest,
): string {
  return JSON.stringify(
    SetConnectionLimitsConnectionsConnectionIdLimitPutRequest$outboundSchema
      .parse(setConnectionLimitsConnectionsConnectionIdLimitPutRequest),
  );
}
export function setConnectionLimitsConnectionsConnectionIdLimitPutRequestFromJSON(
  jsonString: string,
): SafeParseResult<
  SetConnectionLimitsConnectionsConnectionIdLimitPutRequest,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      SetConnectionLimitsConnectionsConnectionIdLimitPutRequest$inboundSchema
        .parse(JSON.parse(x)),
    `Failed to parse 'SetConnectionLimitsConnectionsConnectionIdLimitPutRequest' from JSON`,
  );
}
